module.exports = __webpack_public_path__ + "media/images/members/maria_jose_martinez_lopez-aaa03ad72cdec21335100007fbe685dd.jpg";